import { render } from "./register.vue?vue&type=template&id=1c0b8186&scoped=true"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"

import "./register.vue?vue&type=style&index=0&id=1c0b8186&scoped=true&lang=css"

import exportComponent from "/Users/h5/Desktop/project/外包/huiduoduo/chn-link/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c0b8186"]])

export default __exports__